import { RouteObject } from 'react-router-dom'

import PrivateRoute from 'component/common/private-route'
import { FEATURE } from 'constants/feature'
import P2PLending from 'pages/p2p'
import CreateP2P from 'pages/p2p/create'
import P2PDetail from 'pages/p2p/p2p-detail'
import { PAGES } from 'routes/index'

export const p2pRoutes: RouteObject[] = [
  {
    path: PAGES.P2P_LENDING,
    element: (
      <PrivateRoute feature={FEATURE.P2P_LENDING}>
        <P2PLending />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.P2P_LENDING_CREATE,
    element: (
      <PrivateRoute feature={FEATURE.P2P_LENDING} requireCRUD>
        <CreateP2P />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.P2P_LENDING_DETAIL,
    element: (
      <PrivateRoute feature={FEATURE.P2P_LENDING}>
        <P2PDetail />
      </PrivateRoute>
    ),
  },
]
